import {FrontWebRadioDetailModel} from "../../../../../generated";
import RadioHeadStyle from "./RadioHead.module.scss";
import {Heart} from "./Heart";
import {Now} from "./Now";
import {Play} from "./Play";
import {LogoBox} from "../../../../../components/Item/Image/LogoBox";
import {useNowSongKey} from "../../../../../queriesKeys/useNowSongKey";
import {useQuery} from "@tanstack/react-query";
import {startTransition, useEffect, useState} from "react";

type HeadProps = {
    radio: FrontWebRadioDetailModel,
}

export const RadioHead = (props: HeadProps) => {
    const {
        logo,
        name,
        slogan,
        slug,
        gradientColorFrom,
        gradientColorTo,
    } = props.radio

    const [enable, setEnable] = useState(false);

    const { data: dataNow } = useQuery({ ...useNowSongKey(props.radio.slug),  enabled: enable, refetchInterval: 15000 });

    useEffect(()=> {
        startTransition(()=>setEnable(true));
    },[]);



    const now = dataNow;

    return (
        <>
            <div className={`d-flex ${RadioHeadStyle.Head} flex-column flex-md-row `}>
                <div
                    className={`flex-fill d-flex justify-content-md-start justify-content-center flex-column flex-sm-row`}>
                    <LogoBox src={logo} alt={`Logo ${name}`} className="align-self-center"/>
                    <div
                        className={`text-center text-md-start flex-fill-md-start align-self-center ${RadioHeadStyle.Title} mt-5 mt-sm-0`}>
                        <h1 className={"text-center text-sm-start "}>
                            <strong>{name}</strong>
                        </h1>
                        {slogan ? <span
                            className={"text-center text-sm-start " + RadioHeadStyle.Small}>{slogan}</span> : false}
                    </div>
                </div>
                <div
                    className={`${RadioHeadStyle.playerAndSong} ${!now ? RadioHeadStyle.notSong : ""} d-flex align-self-center  justify-content-center ${!now ? "justify-content-md-end" : ""} flex-column flex-sm-row mt-5 mt-md-0`}>
                    <div className={"d-flex align-self-center position-relative"}>
                        <Play  radio={props.radio} className={"align-self-center"}/>
                        <Heart color={props.radio.linkColor} slug={slug} className={"align-self-center ms-sm-4 ms-lg-5  ms-0"}/>
                    </div>
                    {now  ? <Now color={props.radio.linkColor} now={now} className={"align-self-center mt-5 mt-md-0"}/> : null}
                </div>
            </div>
            {gradientColorFrom && gradientColorTo ? <style>{`
                .${RadioHeadStyle.Head} {
                    background: linear-gradient(180deg, ${gradientColorFrom} 0%, #FFFFFF 0.01%, ${gradientColorTo} 300%);
                }
            `}</style>: null}
        </>
    );

}